export default {
  "language": "es",
  "message":
    {
      "title": "Calculadora de bonificaciones de vivienda para ingresos mixtos",
      "zoningDistrict": "Seleccione un distrito de zonificación",
      "affordabilityLevel": "Seleccione un nivel de asequibilidad",
      "allThatApply": "Seleccione todas las opciones que correspondan.",
      "springGardenS": "¿El proyecto está ubicado al sur de Spring Garden Street",
      "yes": "Sí",
      "no": "No",
      "affordability": {
        "lowIncome": "Bajos ingresos",
        "moderateIncome": "Ingresos moderados",
      },
      "lotAreaSqft": "Introduzca el área del lote en pies cuadrados",
      "buildingHeight": "Introduzca la altura del edificio",
      "totalUnits": "Número propuesto de unidades en proyecto:",
      "unitsEarnedLow": "Unidades adicionales ganadas (ingresos bajos):",
      "unitsEarnedMod": "Unidades adicionales ganadas (ingresos moderados):",
      "greenRoofBonus": "Número de unidades de bonificación Green Roof:",
      "modIncomePayment": "Pago estimado de ingresos moderados:",
      "lowIncomePayment": "Pago estimado para personas de bajos ingresos:",
      "requiredAffordableUnits": "Unidades asequibles obligatorias/min:",
      "requiredMinAffordableUnits": "Unidades asequibles obligatorias/MIN:",
      "totalRequiredAffordabilityUnits": "Total de unidades asequibles requeridas:",
      "additionalFar": "Más de las FAR ganadas:",
      "totalFar": "FAR total:",
      "totalFloor": "Superficie total permitida:",
      "overlay": {
        "fithDistrict": "Este proyecto se encuentra dentro del Quinto Distrito Superpuesto (/VDO).",
        "greenRoof": "Este proyecto ganará una bonificación por techo verde.",
        "minMixed": "Este proyecto se encuentra dentro de la superposición de barrios de ingresos mixtos de /MIN.",
        "todDevelopement": "Este proyecto se encuentra dentro de la capa de desarrollo orientado al tránsito de /TOD.",
      },
      "sFHA": [
        "Zona Especial de Riesgo de Inundación",
      ],
      "numberOfDwellingUnits": "Número de unidades de vivienda permitidas en virtud de la zonificación básica:",
      "about": "Acerca de",
      "aboutTitle": "Acerca del bono de vivienda para personas con ingresos mixtos",
      "aboutSubTitle": "¿Cómo usar la calculadora",
      "paragraphOne": "El bono de vivienda para personas con ingresos mixtos es para desarrolladores que agreguen viviendas asequibles a sus proyectos o contribuyan a un fondo que apoya viviendas asequibles. A cambio, el desarrollo obtiene más superficie, altura y/o unidades de vivienda «por derecho». Los desarrolladores pueden elegir entre dos niveles de bonificación. El nivel de ingresos moderado es una bonificación menor, pero tiene estándares de asequibilidad menos estrictos o un monto de pago más bajo. El nivel de ingresos bajos es una bonificación mayor, pero tiene estándares de asequibilidad más estrictos o un monto de pago más alto.",
      "paragraphTwo": {
        "text": "La calculadora de bonificaciones de vivienda para personas con ingresos mixtos se utiliza para estimar con precisión lo siguiente:",
        "bullets": [
          "Número total de unidades permitidas.",
          "Número total de unidades asequibles que tendrás que proporcionar.",
          "Cuota sustitutiva que se pagará por un desarrollo que utilice el bono de vivienda para personas de ingresos mixtos.",
        ],
      },
      "paragraphThree": {
        "text": "Para empezar, seleccione el distrito de zonificación base de la propiedad e introduzca su área de lote. También debe seleccionar los distritos superpuestos aplicables. Puedes usar",
        "link": {
          "text": "Atlas",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "para encontrar esta información.",
      },
      "finalConfirmation": "Esta calculadora se utilizará para la planificación conceptual de proyectos. En caso de discrepancia entre la calculadora y el Código de Zonificación de Filadelfia, regirá el Código de Zonificación de Filadelfia. El personal de la Comisión de Planificación de la Ciudad de Filadelfia realizará la confirmación final de las unidades, la cantidad requerida de unidades asequibles y/o el monto de la tarifa sustitutiva durante la revisión de los permisos de zonificación.",
      "resources": "Recursos",
      "code1": {
        "link": {
          "text": "Código de Filadelfia — 14-702 (7) — Bono de vivienda para personas con ingresos mixtos",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Código de Filadelfia — 14-533 — Distrito de Superposición Vecinal de Ingresos Mixtos",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Hojas informativas sobre bonos de vivienda para personas de ingresos mixtos",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};